import * as React from 'react';
import { HelpYouSellContainer } from '../containers/HelpYouSellContainer';
import { SellWithCianContainer } from '../containers/SellWithCianContainer';
import { HowItWorksContainer } from '../containers/HowItWorksContainer';
import { ByCianStatisticsContainer } from '../containers/ByCianStatisticsContainer';
import { HelpFromPartners } from '../components/HelpFromPartners';
import { FormBannerContainer } from '../containers/FormBannerContainer';
import { FaqContainer } from '../containers/FaqContainer';
import { ModalFormContainer } from '../../common/containers/ModalFormContainer';
import { useSetSeenLandingInCookie } from '../../common/hooks/useSetSeenLandingInCookie';
import { StickyPromo } from 'shared/common/containers/StickyPromo/StickyPromo';
import { useFillApplicationStickyButtons } from 'shared/common/containers/StickyPromo/useFillApplicationStickyButtons';
import { EPageName } from '../../common/constants/pages';
import { QualityCriteriaModalContainer } from '../containers/QualityCriteriaModalContainer';
import { ReferralBannerContainer } from '../containers/ReferralBanner';
import { GarantLabel } from '../components/GarantLabel';
import { HowWorkGarantContainer } from '../containers/HowWorkGarant';

export const PageContainer: React.FC = () => {
  useSetSeenLandingInCookie();
  useFillApplicationStickyButtons({ landing: 'seller' });

  return (
    <>
      <GarantLabel />
      <HelpYouSellContainer />
      <SellWithCianContainer />
      <HowItWorksContainer />
      <HowWorkGarantContainer />
      {/* <KeyBannerContainer /> Скрыли */}
      <ByCianStatisticsContainer />
      {/* <YourOwnOrWithAgentContainer /> Убрали до переработки дизайна */}
      <ReferralBannerContainer />
      <HelpFromPartners />
      <FormBannerContainer />
      <FaqContainer />
      <ModalFormContainer modalPageType={EPageName.LandingSeller} />
      <QualityCriteriaModalContainer />
      <StickyPromo landing="seller" />
    </>
  );
};
